// redux/sagas/dashboardSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getNotificationRequest,
  getNotificationSuccess,
  getNotificationFailure,
} from "./notificationSlice";
import { toast } from "react-toastify";

function* fetchNotification(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/notification/all`)
    );

    if (response.data.success) {
      yield put(getNotificationSuccess(response.data));
     // toast.success("Notification fetched successfully");
    } else {
      yield put(
        getNotificationFailure(response.data.message || "Failed to fetch notification")
      );
      toast.error(response.data.message || "Failed to fetch notification");
    }
  } catch (error) {
    yield put(getNotificationFailure(error.message));
    toast.error("Error fetching notification");
  }
}

export function* notificationSaga() {
  yield takeLatest(getNotificationRequest.type, fetchNotification);
}
